// The lists below mirror the pIDR Python source of truth; drift is caught
// by probabilistic_idr/tests/test_frontend_sync.py.
//
// Enabled probabilistic blocking rules, from the Python algo's blocking.py.
// A pIDR run raises "no blocking rules for identifiers" at construction if the
// mapped identifiers satisfy none of these.
export const probabilisticBlockingRules: readonly string[][] = [
  ["first_name", "date_of_birth"],
  ["last_name", "date_of_birth"],
  ["first_name", "postal_code"],
  ["last_name", "postal_code"],
  ["first_name", "street_address"],
  ["last_name", "credit_card_last4"],
  ["first_name", "last_name"],
  ["full_name", "date_of_birth"],
  ["full_name", "postal_code"],
  ["full_name", "credit_card_last4"],
  ["full_name", "phone"],
  ["email"],
  ["first_name", "phone"],
  ["last_name", "phone"],
];

// Address fields feed the composite address_similarity feature; the rest each
// contribute a weighted {id}_similarity feature. `gender` has no weighted
// feature. From the Python algo's matching.py weights + features.py.
export const probabilisticAddressIdentifiers: ReadonlyArray<string> = [
  "street_address",
  "unit_number",
  "city",
  "state",
  "postal_code",
  "country",
];
export const probabilisticScorableIdentifiers: ReadonlyArray<string> = [
  "first_name",
  "last_name",
  "full_name",
  "email",
  "phone",
  "date_of_birth",
  "birth_year",
  "credit_card_last4",
];

export const probabilisticCompositeFeatureNames: ReadonlyArray<string> = [
  "address_similarity",
  "name_email_similarity",
];

// pIDR needs at least one eligible blocking rule and at least one weighted
// feature, otherwise it will fail.
export const canRunProbabilisticMatching = (
  identifiers: ReadonlyArray<string>,
): boolean => {
  const ids = new Set(identifiers);
  const hasBlockingRule = probabilisticBlockingRules.some((rule) =>
    rule.every((id) => ids.has(id)),
  );
  const hasScorableFeature =
    probabilisticScorableIdentifiers.some((id) => ids.has(id)) ||
    probabilisticAddressIdentifiers.some((id) => ids.has(id));
  return hasBlockingRule && hasScorableFeature;
};
